<template>

<div class="grid-content bg-purple">
<h2 style="float: left;">评分列表</h2>
<!--<el-tag
  v-for="item in items"
  :key="item.id"
  :type="item.type"
  @click="selecTopera(item.id,1)"
  :class="{active : item.id===curId}"
  effect="light">
{{ item.label }}
</el-tag>-->
<div class="lu_head" style="float: left;">
	<span v-for="item in items" class="lu_list" :class="{lu_active : item.operatorNum===curId}" @click="selecTopera(item.operatorNum,1)">
  <img :src="item.logo"/>{{ item.operatorName }}</span>
</div>
<div class="table-box">


<el-table
  :data="operator"
  height="550"
  border
  style="width: 100%;">
  <el-table-column
    label="季度"
    width="180">
    <template slot-scope="scope">
      {{scope.row.year}}年第({{scope.row.quarter}})季
    </template>
  </el-table-column>
  <el-table-column
    prop="operatorName"
    label="运营企业"
    width="180">
  </el-table-column>
  <el-table-column
    prop="totalPoints"
    label="季度评分">
  </el-table-column>
  <el-table-column
    prop="grade"
    label="季度评分排名">
  </el-table-column>

  <el-table-column
    fixed="right"
    label="操作">
    <template slot-scope="scope">
      <el-button
        size="mini"
        type="success"
        @click="openEdit(scope.row.gradeId,0)"
      >查看详情</el-button>
    </template>
  </el-table-column>
</el-table>
<el-pagination
	v-if="operatortotal>10"
  background
  layout="prev, pager, next"
  :page-size="operatorpageSize"
  @current-change="setselecTopera"
  :total="operatortotal">

</el-pagination>
</div>
  </div>
</template>
<script>
export default {
  name: "Scorelist",
  data(){
    return {
      items: [
        {   id:1,
          type: 'success',
          code:'MT'
        },
        {   id:2,
          type: 'info',
          code:'HB'
        },
        {
          id:3,
          type: 'danger',
          code:'DD'
        },
      ],
      operatorpage:1,
      operatortotal:0,
      operatorpageSize:10,
      operator:[],
      curId:1,
    }
  },
  beforeRouteEnter(to,from,next){

    next((vm)=>{

    });
  },
  created(){

  },
  mounted () {
    this.selecTopera(1,1)
		this.selectAllOperator()
  },
  methods: {
			//获取所有企业
			selectAllOperator() {
				let that = this;
				this.$axios
					.get('/api/operator/selectAllOperator')
					.then(function(res) {
						if(res.data.code == 200) {
							that.items = res.data.data;
							that.curId = res.data.data[0].operatorNum
						}

					})
			},
    // 获取评分列表
    selecTopera(index,page){
      let that = this;
      this.curId = index;
      let operators ={
        page:page,
        pageSize:this.operatorpageSize,
        operatorNum:index ,
      }
      this.$axios.defaults.withCredentials=true;
      this.$axios
        .post('/api/grade/selectGradeList',operators)
        .then(function (res) {
          that.operatortotal = res.data.data.total;
          that.operator = res.data.data.list;
        }).catch(function (error) { // 请求失败处理
        console.log("服务器错误"+error);
      });
    },
    setselecTopera(operatorpage){
      this.operatorpage = operatorpage;
      this.selecTopera(this.curId,operatorpage);
    },
    openEdit(cid,typeid){
       this.$router.push({name:'Ashowscore' , params:{cid:cid ,curId:this.curId, typeid:typeid}})
    },
  },
  watch: {

  },
}
</script>

<style scoped>


	.lu_head {
		float: left;
		overflow: hidden;
		width: calc(100% - 120px);
	}
	
	.lu_list {
		font-size: 24px;
		padding: 10px 0;
		line-height: 26px;
		border-radius: 5px;
		margin: 5px 0 5px 20px;
		max-width: 116px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		float: left;
		color: #909399;
		cursor: pointer;
	}
	
	.lu_list img {
		width: 24px;
		height: 24px;
		margin-right: 10px;
		position: relative;
		top: 2px;
		filter: grayscale(90%);
	}
	
	.lu_list:hover {
		color: #333;
	}
	
	.lu_list:hover img {
		filter: grayscale(0%);
	}
	
	.lu_active {
		color: #333 !important;
	}
	
	.lu_active img {
		filter: grayscale(0%) !important;
	}
	
</style>



// WEBPACK FOOTER //
// src/view/admin/Scorelist.vue